// src/services/queryClient.js
import { QueryClient } from '@tanstack/react-query';
import { openDB } from 'idb';

// Función para persistir los datos en IndexedDB
const persistWithIndexedDB = async (queryClient) => {
  const db = await openDB('react-query-cache', 1, {
    upgrade(db) {
      db.createObjectStore('queries');
    },
  });

  const cache = await db.getAll('queries');

  // Si hay datos en IndexedDB, restaurarlos
  cache.forEach(({ queryKey, state }) => {
    queryClient.getQueryCache().build(queryClient, { queryKey }, state);
  });

  // Guardar los datos actualizados en IndexedDB cada vez que cambien
  queryClient.getQueryCache().subscribe((event) => {
    if (event.type === 'queryUpdated') {
      const query = queryClient.getQueryCache().find(event.query.queryKey);
      db.put(
        'queries',
        { queryKey: event.query.queryKey, state: query.state },
        event.query.queryKey
      );
    }
  });
};

// Configuración del queryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24, // 24 horas
      staleTime: 1000 * 60 * 5, // 5 minutos antes de refrescar
    },
  },
});

// Exportar el queryClient y la función persistWithIndexedDB
export { queryClient, persistWithIndexedDB };
